'use client'

import { useEffect } from 'react'

import { JobSearch } from '@types'

import PageViewEvent from 'src/app/page-view-event'

import {
  emailInstantJobMatchMoreJobsButtonClickedEvent,
  emailInstantJobMatchViewAllButtonClickedEvent,
} from '@lib/analytics-events'

type SerpEventsProps = {
  search: JobSearch
}

export default function SerpEvents({ search }: SerpEventsProps): JSX.Element {
  useEffect(() => {
    if (search.instantJobMatch) {
      emailInstantJobMatchMoreJobsButtonClickedEvent(search)
    }
    if (search.viewAllJobs) {
      emailInstantJobMatchViewAllButtonClickedEvent(search)
    }
  }, [search])
  return <PageViewEvent location="serp" />
}
